import React, { Component } from "react";
import Select from 'react-select';
import axios from "axios";
import styles from "./styles/AcceptTalent.scss";
import sectors from "../Careers/Sectors";
import skills from "./Skills";
import experience from "./Experience";
import Loader from "../../Loader/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import DecModal from "./DecModal";

export default class AcceptTalent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saved_recently: false,
      error_saving: false,
      error_loading: undefined,
      deleted: undefined,
      nominee: {
        _id: undefined,
        first_name: undefined,
        last_name: undefined,
        email: undefined,
        phone: undefined,
        experience: undefined,
        skills: undefined,
        education: undefined,
        recent_position: undefined,
        declaration: undefined,
        description: undefined,
        nominator: undefined,
        nomination_date: undefined,
        update_date: undefined,
        linkedin: undefined,
        job_applied: undefined,
        archive: undefined,
        sectors: []
      },
      employer_name: undefined
    };
  }

  async componentDidMount() {
    // Make call to database using ID from URL
    let id = this.props.location.search.substring(1);
    let cd = new Date();
    await axios
      .post("/api/kingstonconnect/getnominee/", {"_id": id})
      .then(res => {
        this.setState({
          saving: false,
          nominee: {
            _id: res.data._id,
            first_name: res.data.first_name,
            last_name: res.data.last_name,
            email: res.data.email,
            phone: res.data.phone,
            experience: res.data.experience,
            skills: res.data.skills,
            education: res.data.education,
            recent_position: res.data.recent_position,
            declaration: res.data.declaration,
            description: res.data.description,
            linkedin: res.data.linkedin,
            job_applied: res.data.job_applied,
            nominator: res.data.nominator,
            nomination_date: res.data.nomination_date,
            update_date:
              cd.getFullYear() + "-" +
              ((cd.getMonth()+1 <= 9) ? ("0" + (cd.getMonth()+1)) : (cd.getMonth()+1)) + "-" +
              ((cd.getDate() <= 9) ? ("0" + cd.getDate() ): cd.getDate() ),
            sectors: res.data.sectors,
            archive: res.data.archive
          }
        });
      })
      .catch(e => {
        this.setState({
          error_loading: true
        })
      })
      .then(() => {
        console.log(this.state.nominee)
        if (this.state.nominee._id && this.state.nominee.nominator.includes('@')) {
          let nominator = this.state.nominee.nominator.split(" ");
          this.setState({
            employer_name: nominator[0] + " " + nominator[1],
            employer_email: nominator[2]
          });

        } else {

          axios
          .post("/api/kingstonconnect/getemployer/", {"_id": this.state.nominee.nominator})
          .then(res => {
            this.setState({
              employer_name:
                res.data.first_name + " " +
                res.data.last_name,
              employer_email: res.data.email
            });
            return Promise.resolve(1);
          })
          .catch(e => console.log(e))
        }
    });
  }

  handleDataChange = (e) => {
    this.setState({
      error_saving: false,
      saved_recently: false,
      nominee: {
        ...this.state.nominee,
        [e.target.id]: e.target.value
      }
    });
  }

  handleSectorSelect = (e) => {
    this.setState({
      error_saving: false,
      saved_recently: false,
      nominee: {
        ...this.state.nominee,
        sectors: e
      }
    });
  }


    handleExperienceSelect = (e) => {
      this.setState({
        error_saving: false,
        saved_recently: false,
        nominee: {
          ...this.state.nominee,
          experience: e
        }
      });
    }

  compare = (a,b) => {
    return a.label > b.label ? 1 : b.label > a.label ? -1 : 0;
  }

  handleSkillSelect = (e) => {
    this.setState({
      error_saving: false,
      saved_recently: false,
      nominee: {
        ...this.state.nominee,
        skills: e
      }
    })
  }

  setDeclaration = dec => {
    this.setState({
      nominee: {
        ...this.state.nominee,
        declaration: dec
      }
    });
  }

  submitForm = (e) => {
    console.log(this.state.nominee)
    e.preventDefault();
    this.setState({ saving: true})
    axios
      .post("/api/kingstonconnect/updatenominee/", this.state.nominee)
      .then(res => {
        this.setState({
          error_saving: false,
          saved_recently: true,
          saving: false
        })
      })
      .catch(e => {
        this.setState({
          error_saving: true,
          saved_recently: false,
          saving: false
        })
        console.log(e)
      });
  }

  deleteNominee = () => {
    axios
      .post("/api/kingstonconnect/deletenominee/", {"_id" : this.state.nominee._id})
      .then(res => {
        this.setState({ deleted: true })
      })
      .catch(e => {
        this.setState({ deleted: false })
      });
  }

  render() {
    if (this.state.error_loading){
      return (
        <div className={styles.page}>
          <h5>This invitation is invalid.</h5>
        </div>
      )
    } else if (this.state.nominee._id === undefined){
      return ( <Loader /> )
    } else {
    return (
      <div className={styles.page}>
        <h1>You've Been Invited</h1>
        <form className={styles.form} onSubmit={this.submitForm}>
        <p>You have been referred to join KingstonConnect.</p>
        <br/>
        <div className="row">
          <div className="form-group col-sm-6">
            <label>First Name</label>
            <input onChange={this.handleDataChange} defaultValue={this.state.nominee.first_name} required className="form-control" id="first_name"/>
          </div>
          <div className="form-group col-sm-6">
            <label>Last Name</label>
            <input onChange={this.handleDataChange} defaultValue={this.state.nominee.last_name} required className="form-control" id="last_name"/>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-sm-6">
            <label>Email Address</label>
            <input onChange={this.handleDataChange} defaultValue={this.state.nominee.email} required type="email" id="email" className="form-control" aria-describedby="emailHelp" />
          </div>
          <div className="form-group col-sm-6">
            <label>Phone Number</label>
            <input onChange={this.handleDataChange} defaultValue={this.state.nominee.phone} type="tel" id="phone" className="form-control" />
          </div>
        </div>
        <div className="form-group">
          <label>Career Sector(s)</label>
          <small className="form-text text-muted">You can only select up to 5 sectors.</small>
          <Select
            onChange={this.handleSectorSelect}
            value={this.state.nominee.sectors}
            options={
              this.state.nominee.sectors.length < 5
              ? sectors.slice(1)
              : []
            }
            isMulti={true}
            id="sectors"
            placeholder="Select or type to search"
            isSearchable />
        </div>
        <div className="form-group">
        {/*
          onChange={this.handleDataChange} defaultValue={this.state.nominee.expertise}
        */}
          <p>Experience Level</p>
        </div>
        <div className='form-group'>
          <Select
            onChange={this.handleExperienceSelect}
            value={this.state.nominee.experience}
            options={experience}
            isMulti={false}
            id="experience"
            isSearchable
          />
        </div>
        <div className="form-group">
          <label>Most Recent Job Experience</label>
          <input onChange={this.handleDataChange} defaultValue={this.state.nominee.recent_position} id="recent_position" className="form-control" />
        </div>
        <div className="form-group">
          <label>Link to LinkedIn</label>
          <input onChange={this.handleDataChange} defaultValue={this.state.nominee.linkedin} id="linkedin" className="form-control" />
        </div>
        <div className="form-group">
          <label>Skills</label>
          <small className="form-text text-muted">You can only select up to 10 skills.</small>
          <Select
            onChange={this.handleSkillSelect}
            value={this.state.nominee.skills}
            options={
              this.state.nominee.skills.length < 10
              ? skills.sort(this.compare)
              : []
            }
            isMulti={true}
            id="skills"
            placeholder="Select or type to search"
            isSearchable />
          {/*<input onChange={this.handleDataChange} defaultValue={this.state.nominee.skills} id="skills" className="form-control" /> */}
        </div>
        <div className="form-group">
          <label>Education</label>
          <small className="form-text text-muted">Please enter relevant educational information in the following format: Degree/Area of Study, School/Institution</small>
          <input onChange={this.handleDataChange} defaultValue={this.state.nominee.education} id="education" className="form-control" />
        </div>
        <div className="form-group">
          <label>Designated Groups</label>
          <small className="form-text text-muted">This field is optional.<br/> Click here to declare Minority groups that you self-identify with. </small>
          <DecModal
            setDeclaration={this.setDeclaration}
            declaration={this.state.nominee.declaration}
          />
        </div>
        <div className="row">
          <div className="form-group col-sm-6">
            <label>Nominator</label>
            <input readOnly disabled
              value={this.state.employer_name
                ? this.state.employer_name
                : this.state.nominee.nominator}
              id="nominator" className="form-control" />
          </div>
          <div className="form-group col-sm-6">
            <label>Nomination Date</label>
            <input readOnly disabled defaultValue={this.state.nominee.nomination_date} id="nomination_date" className="form-control" />
          </div>
        </div>
        <div className="form-group">
          <label>Nominator Email</label>
          <input readOnly disabled defaultValue={this.state.employer_email} id="employer_email" className="form-control" />
        </div>
        { this.state.nominee.job_applied &&

          <div className="form-group">
            <label>Applied Job Title</label>
            <input readOnly disabled defaultValue={this.state.nominee.job_applied} id="job_applied" className="form-control" />
          </div>
        }
        <div className="form-group">
          <label>Nomination Description</label>
          <textarea readOnly disabled rows="4" defaultValue={this.state.nominee.description} id="description" className="form-control" />
        </div>

        {this.state.nominee.archive &&
          <div className="alert alert-danger" role="alert">
            <strong> Your account is archived.</strong> This means employers cannot see your profile. Please contact the system administrator.
          </div>
        }

        {this.state.saved_recently &&
          <div className="alert alert-success" role="alert">
            <strong>Saved!</strong> Thank you for completing your nomination form. Please bookmark this URL so you can return and make changes at a later date. To learn more about the Kingston Connect program, click here
            <br/>
            <button
              onClick={() => window.open("https://possiblemadehere.org/kingston-connect")}
              className="btn btn-primary"
              type="button">
                Go
              </button>
          </div>
        }
        {this.state.error_saving &&
          <div className="alert alert-danger" role="alert">
            <strong>Uh oh!</strong> Change a few things up and try submitting again.
          </div>
        }

        {!this.state.deleted && <div className="form-group">
          <strong>Bookmark this page to make changes to your profile in the future </strong> <br/>
          <small className="form-text text-muted">By clicking "Save", you verify that the information above is all correct and consent to sharing this information with employers in the Kingston area.</small>
          <button type="submit" className="btn btn-primary" style={{marginTop: "1%"}}>
            {"Save "}
            {this.state.saving &&
              <FontAwesomeIcon spin
              icon={faSpinner}
              />
            }
          </button>
        </div>}


      </form>

      Interested in Career opportunities in Kingston? Check out our Find Your Career tool! <br/>
      <button className='btn btn-info mt-3'
        onClick={() => window.open("https://possiblemadehere.org/find-a-job")}>
        Career Tool
      </button>
      <div className={styles.form}>
        {this.state.deleted === true &&
          <div className="alert alert-success" role="alert">
          <strong>Deleted!</strong> Your account will be deleted within 48 hours.
          </div>
        }
        {this.state.deleted === false &&
          <div className="alert alert-danger" role="alert">
          <strong>Error!</strong> Something went wrong, please refresh the page and try again.
          </div>
        }
        <small className="form-text text-muted">By clicking "Delete My Profile", you are permanently deleting your profile and information from our servers. This can take up to 48 hours to successfully complete.</small>
        <button className="btn btn-danger mb-4" onClick={this.deleteNominee} style={{marginTop: "1%"}}>Delete My Profile</button>
      </div>
    </div>
  )}}
}



// WEBPACK FOOTER //
// ./src/components/pages/KingstonConnect/AcceptTalent.js